
import { Component, Input, Output, EventEmitter, ElementRef } from '@angular/core';
@Component({
	selector: 'alert',
	templateUrl: "./alert.html",
	styles: [require("./alert.scss")]
})
export class Alert {
	private _visible: boolean
	private _type: string

	@Input() set type(type: string) {
		this._type = type;
		if(type == "success"){
			setTimeout(() => this.close(), 3000);
		}
	}

	@Input() set visible(visible: boolean) {
		this._visible = visible;
		if (visible) {
			// Alert message has a fixed position now and we don't have to scroll to top (see T1595)
			//window.scrollTo(0, 0);
		}
	}

	get visible() {
		return this._visible;
	}

	get type() {
		return this._type;
	}

	@Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	constructor(private element: ElementRef) {

	}

	close() {
		this.visibleChange.emit(false);
	}


}



// WEBPACK FOOTER //
// ./src/app/ui-helper/alert/alert.component.ts